/**
 *
 * Document Ready Functions
 *
 **/

$(document).ready(function() {

  $('.single-option-selector').change(function(){
    if ($(this).val() == 'Q2000PSP - Contact us for pricing'){
      $('#ProductPrice').html('<em><a href="/pages/contact-info" target=="_blank">Contact us</a> for pricing</em>');
      $('#AddToCart').hide();
    } else {
      $('#ProductPrice').show();
      $('#AddToCart').show();
    }
  });

});

/**
 *
 * Window Load Functions
 *
 **/

$(window).load(function() {


  if ($('.single-option-selector').val() == 'Q2000PSP - Contact us for pricing'){
    $('#ProductPrice').html('<em><a href="/pages/contact-info" target=="_blank">Contact us</a> for pricing</em>');
    $('#AddToCart').hide();
  } else {
    $('#ProductPrice').show();
    $('#AddToCart').show();
  }
 
  
  setTimeout(function(){
    var windowWidth                  = $(window).width();

    $.fn.matchHeight._maintainScroll = true;

    if (windowWidth >= 768) {
      $(".eh").matchHeight();
    }
  }, 200);

  setTimeout(function(){
    var windowWidth                  = $(window).width();

    $.fn.matchHeight._maintainScroll = true;

    if (windowWidth >= 768) {
      $(".eh").matchHeight();
    }
  }, 1000);

});

/**
 *
 * Window Scroll Functions
 *
 **/

$(window).scroll(function(event) {

});



/**
 *
 * Window Resize Functions
 *
 **/

$(window).resize(function() {

  /*----------  Off Canvas Menu Hide  ----------*/
  var windowWidth = $(window).width();

  if (windowWidth >= 768) {

    // MatchHeight Update
    $.fn.matchHeight._update();

  }


});
